import { render, staticRenderFns } from "./RegApplicationFormFields.vue?vue&type=template&id=65d09499&scoped=true"
import script from "./RegApplicationFormFields.vue?vue&type=script&lang=js"
export * from "./RegApplicationFormFields.vue?vue&type=script&lang=js"
import style0 from "./RegApplicationFormFields.vue?vue&type=style&index=0&id=65d09499&prod&scoped=true&lang=css"
import style1 from "./RegApplicationFormFields.vue?vue&type=style&index=1&id=65d09499&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d09499",
  null
  
)

export default component.exports